"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createQueue = function createQueue() {
  var trackingBuffer = [];

  return {
    add: function add(event) {
      trackingBuffer.push(event);
    },
    removeAll: function removeAll() {
      var oldTrackingBuffer = trackingBuffer.slice(0);

      trackingBuffer.splice(0, trackingBuffer.length);
      return oldTrackingBuffer;
    }
  };
};

exports.default = createQueue;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-impression-tracking/build/createDefaultQueue.js
 ** module id = 49
 ** module chunks = 0
 **/